module.exports = __webpack_public_path__ + "img/checkbox-empty.9f3c591d.png";